export enum ConfigType {
  PatientChartField = 'PATIENT_CHART_FIELD',
  StaffTitle = 'STAFF_TITLE',
}
